<template>
  <div>
    <div class="card text-center">
      <b-row>
        <div class="col-lg-3">
          <b-list-group class="row no-gutters">
            <b-list-group-item class=" col-lg-12 px-2" v-if="account_type != 'teacher'">
              <b-button block :variant="courseView == 'now' ? 'primary' : 'outline-primary'" @click="
                courseView = 'now';
              selectedType = '';
              ">
                {{ $t("edu_courses.current_activities") }}
              </b-button>
            </b-list-group-item>

            <b-list-group-item class="col-lg-12 px-2">
              <b-button block :variant="courseView == 'all' ? 'primary' : 'outline-primary'" @click="getAll()">{{
                $t("edu_courses.all") }}
              </b-button>
            </b-list-group-item>
          </b-list-group>
        </div>

        <div class="col-lg-9">
          <b-list-group horizontal v-if="courses.length > 0" style="overflow-x: scroll"
            class="h-100 d-flex align-items-center py-2">
            <!-- Controls -->

            <!-- /Controls -->

            <b-list-group-item v-for="course in courses" :key="course.id" class="col-auto">
              <b-button-group>
                <b-button variant="outline-primary">
                  <b-form-checkbox @change="get()" v-model="selectedContentIds" :value="course.id">
                  </b-form-checkbox>
                </b-button>
                <b-button :variant="courseView == course.id ? 'primary' : 'outline-primary'
                  " @click="courseClick(course.id)">
                  <span v-if="course.flixable == 0">{{ course.code }}-{{ course.name }}</span><span v-else>{{
                    $t("edu_courses.teacher_activities") }}
                  </span>
                </b-button>
              </b-button-group>
            </b-list-group-item>
          </b-list-group>
          <b-spinner v-else type="grow" label="Loading..." class="loading" />
        </div>
      </b-row>
    </div>
    <b-row>
      <b-col lg="2" class="mb-4 mb-lg-0">
        <b-card class="text-center h-100">
          <b-button v-if="selectedContentIds.length == 1" variant="outline-primary" block @click="introductoryFile()">
            <!-- <feather-icon :icon="item.icon" class="amr-50" /> -->
            <span class="align-middle">
              {{ $t("edu_courses.introductory_file") }}</span>
          </b-button>
          <template v-for="item in types">
            <b-button :key="item.type" v-if="activeTypes.includes(item.type)" :variant="selectedType == item.type ? item.color : 'outline-' + item.color
              " block @click="selectType(item.type)">
              <feather-icon :icon="item.icon" class="amr-50" />
              <span class="align-middle"> {{ item.title }}</span>
            </b-button>
          </template>
        </b-card>
      </b-col>
      <b-col lg="10" v-if="isShowContent == 1">
        <b-row v-if="load == false">
          <template v-if="contents.length > 0">
            <b-col lg="4" md="6" sm="12" v-for="item in contents" :key="item.id">
              <b-card :border-variant="getType(item.type).color" footer-tag="footer">
                <b-card-body>
                  <b-card-title>{{ item.name }} </b-card-title>
                  <b-card-sub-title class="mb-2">
                    <span :class="`text-${getType(item.type).color}`">
                      <feather-icon :icon="getType(item.type).icon" class="mr-50" />
                      {{ getType(item.type).title }}
                    </span>
                  </b-card-sub-title>

                  <b-card-text style="max-height: 66px; overflow: hidden" v-html="item.description">
                  </b-card-text>
                </b-card-body>
                <b-list-group flush>
                  <b-list-group-item>{{ $t("edu_courses.start_in") }} :{{
                    item.start_in.toLocaleString()
                  }}</b-list-group-item>
                  <b-list-group-item>
                    {{ $t("edu_courses.end_in") }} :
                    {{ item.end_in.toLocaleString() }}</b-list-group-item>
                </b-list-group>
                <div>
                  <template v-if="checkTime(item)">
                    <b-button block variant="relief-secondary">
                      لم تبدأ بعد
                    </b-button>
                  </template>
                  <b-button v-else-if="item.type == 'direct_lectures' &&
                    item.data.online_class.is_end == 0
                    " block :variant="`relief-${getType(item.type).color}`" @click="showContent(item)">
                    دخول المحاضرة
                  </b-button>
                  <div v-else>
                    <b-button block v-if="$role != 'student'" :to="{
                      name: 'SessionAttendance',
                      params: {
                        session_room_id: roomId,
                        session_id: item.online_class_id,
                      },
                    }">

                      <i class="fas fa-clipboard-check" style="display: inline-block; margin: 0; padding: 1px 5px"></i>

                      {{ $t("attendance.attendance_record") }}

                    </b-button>

                    <b-button block :variant="`relief-${getType(item.type).color}`" @click="showContent(item)">
                      {{ $t("site.read") }}
                    </b-button>
                  </div>
                </div>
              </b-card>
            </b-col>
          </template>
          <template v-else>
            <b-col lg="3">
              <b-card border-variant="info" footer-tag="footer">
                <b-card-body>
                  <b-card-title>
                    <feather-icon icon="AlertOctagonIcon" />
                  </b-card-title>
                  <b-card-text style="height: 66px; overflow: hidden">
                    {{ $t("site.no_data_found") }}
                  </b-card-text>
                </b-card-body>

                <template #footer> </template>
              </b-card>
            </b-col>
          </template>
        </b-row>
        <b-spinner v-else type="grow" label="Loading..." class="loading" />

        <!-- <b-card class="text-center" style="height: 70vh"></b-card> -->
      </b-col>
      <b-col lg="10" v-else-if="isShowContent == 2">
        <b-card header-tag="header">
          <b-card-header>
            <b-card-title>
              {{ $t("edu_courses.introductory_file") }}</b-card-title>
            <feather-icon icon="CornerLeftUpIcon" size="18" class="cursor-pointer" @click="back()" />
          </b-card-header>
          <b-card-body style="min-height: 30vh">
            <b-card-text>
              <object style="width: 100%; height: 80vh" :data="eduCourses.introductory_file_path" type="application/pdf">
                <embed style="width: 100%; height: 80vh" :src="eduCourses.introductory_file_path"
                  type="application/pdf" />
              </object>
            </b-card-text>
            <hr />
            <b-card-text v-html="eduCourses.description">
              <b-card-title>{{ $t("edu_courses.description") }}</b-card-title>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="10" v-else>
        <show-content-vue :content="content" :eduProgram="eduProgram" :type="getType(content.type)" @click="back()" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Auth from "@/Apis/Auth";
import EduCoursesController from "../../../Controllers/EduCoursesController";
import Exam from "../Exams/Exam.vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";
import BCardCode from "@/@core/components/b-card-code/BCardCode.vue";
import config from "@/config/config";
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import SettingController from "@/Controllers/SettingController";
import ShowContentVue from "./components/ShowContent.vue";
import FailedUsersRoomsController from '@/Controllers/FailedUsersRoomsController';
const eduCourses = new EduCoursesController();
export default {
  components: {
    Exam,
    BCardActions,
    BCardCode,
    ShowContentVue,
  },
  data() {
    return {
      selectedContentIds: [],
      selectedType: "",
      eduProgram: {},
      announcement: [],
      polls: [],
      student_grades: "",
      room: "",
      courses: [],
      contents: [],
      recordIds: [],
      isShowContent: 1,
      content: {},
      courseView: "now",
      load: false,
      type: "all",
      roomId: 0,

      account_type: Auth.USER.account_type,
      activeTypes: [],
      eduCourses: {},
      time: {},
    };
  },

  async created() {
    this.load = true;
    this.$mobileTitle.label = this.$i18n.t('edu_courses.edu_courses');
    // this.$forceUpdate();
    this.eduProgram = Auth.CurrentEduProgram();
    if (Auth.USER.account_type == "student") {
      let room = Auth.ROOM.find((a) => a.edu_program_id == this.eduProgram.id);
      this.roomId = room.id;
    } else if (Auth.USER.account_type == "teacher")
      this.roomId = localStorage.getItem("room");

    this.types = eduCourses.Types();
    const failedUser = await (new FailedUsersRoomsController()).GetAll({ filter: 'user_id|' + Auth.USER.id, with: ['eduCourse'] });
    if (Auth.USER.account_type == "teacher") {
      const res = await eduCourses.teacherCourses({
        edu_program: this.eduProgram.id,
      });
      if (res) {
        res.map((e) => {
          this.courses.push(e.course);
        });
      }
    } else {
      const data = await eduCourses.EduCourseProgramsActiveSemester({
        eduProgramId: this.eduProgram.id,
      });
      this.courses = data;
      failedUser.forEach((course, i) => {
        if (course.id) {
          const index = this.courses.findIndex(a => a.id == course.new_edu_course_id);
          if (index > -1)
            this.courses.splice(index, 1);
          this.courses.push(course.edu_course);
        }

      });

     
    }

    this.courses.forEach((element) => {
      this.selectedContentIds.push(element.id);
    });
    let type = localStorage.getItem("courseType");
    this.time = await new SettingController().time();
    if (type == 0) {
      await this.getContentsNow();
    } else if (type == 1) {
      this.courseView = "all";
      this.selectedType = "assessments";
      await this.GetAssessments(this.selectedContentIds);
    } else if (type == 2) {
      this.courseView = "all";
      this.selectedType = "exam";
      await this.getContents(this.selectedContentIds);
    }
    localStorage.setItem("courseType", 0);

    let content = localStorage.getItem("content");
    if (content) {
      this.showContent(JSON.parse(content));
      localStorage.removeItem("content");
    }

    this.load = false;
  },
  methods: {
    checkTime(item) {
      // if (item.type != "direct_lectures") return false;
      const check = new Date(this.time.SERVERTIME);
      const stDate = item.start_in;
      console.log(check, stDate);

      if (check.getTime() >= stDate.getTime()) return false;
      return true;
    },

    courseClick(id) {
      this.selectedContentIds = [];
      this.selectedContentIds.push(id);
      this.courseView = id;
    },
    getAll() {
      this.courseView = "all";
      this.selectedContentIds = this.courses.map((a) => a.id);
    },
    async get() {
      console.log("selectedContentIds", this.selectedContentIds);

      this.contents = [];
      this.isShowContent = 1;

      this.load = true;
      if (this.courseView == "now") {
        this.type = "now";
        await this.getContentsNow();
      } else if (this.courseView == "all") {
        this.type = "";
        if (this.selectedType == "assessments") {
          await this.GetAssessments(this.selectedContentIds);
        } else {
          if (this.selectedType == "") this.selectedType = "voice_lectures";
          await this.getContents(this.selectedContentIds);
        }
      } else {
        this.type = "";
        if (this.selectedType == "assessments") {
          await this.GetAssessments(this.selectedContentIds);
        } else {
          console.log("manaa here");
          await this.getContents(this.selectedContentIds);
        }
      }
      this.activeTypes = this.contents.map((a) => a.type);
      console.log(this.activeTypes);
      this.load = false;
    },
    async selectType(type) {
      this.selectedType = type;
      console.log(this.selectedType);
      await this.get();

      this.contents = this.contents.filter((a) => a.type == type);
    },
    getType(type) {
      let dd = eduCourses.GetType(type);
      return dd;
    },
    showContent(data) {
      if (
        data.type == "direct_lectures" &&
        data.data.online_class.is_end == 0
      ) {
        new OnlineSessionController().joinLecture(data.online_class_id);
      } else {
        this.isShowContent = 3;
        this.content = data;
      }
    },
    async getContentsNow() {
      this.load = true;
      const res = await eduCourses.getContentsNow({
        eduProgramId: this.eduProgram.id,
        room_id: this.roomId,
      });
      res.data.forEach((item) => {
        this.contents.push({
          id: item.get_edu_content.id,
          name: item.get_edu_content.name,
          type: item.get_edu_content.type,
          online_class_id: item.online_class_id,
          start_in: Auth.GetDateTimeZone(item.start_in, true),
          end_in: Auth.GetDateTimeZone(item.end_in, true),
          file: item.get_edu_content.file,
          data: item,
          exam_id: item.get_edu_content.exam_id,
          h5p: item.get_edu_content.h5p_content_id,
          description: item.get_edu_content.description,
        });
      });
      this.activeTypes = this.contents.map((a) => a.type);
      this.load = false;
    },
    async GetAssessments(courseIdArray) {
      this.load = true;
      const res = await eduCourses.GetAssessments({
        eduProgramId: this.eduProgram.id,
        room_id: this.roomId,
        courseIdArray,
      });
      console.log(res);
      res.data.forEach((item) => {
        this.contents.push({
          id: item.id,
          name: item.title,
          type: "assessments",
          description: item.title,
          start_in: Auth.GetDateTimeZone(item.start_date, true),
          end_in: Auth.GetDateTimeZone(item.end_date, true),
          h5p: item.h5p,
          data: item,
          exam_id: null,
          online_class_id: item.online_class_id,
          h5p: item.h5p_content_id,
        });
      });
      this.load = false;
    },
    async getContents(courseIdArray) {
      console.log(this.selectedContentIds);
      this.load = true;
      const res = await eduCourses.GetContents({
        eduProgramId: this.eduProgram.id,
        courseIdArray: this.selectedContentIds,
        type: this.selectedType,
        room_id: this.roomId,
      });
      // res.data.forEach((item) => {
      //   this.contents.push({
      //     id: item.id,
      //     name: item.name,
      //     type: item.type,
      //     description: item.description,
      //     start_in: Auth.GetDateTimeZone(item.rooms[0].pivot.start_in, true),
      //     end_in: Auth.GetDateTimeZone(item.rooms[0].pivot.end_in, true),
      //     file: item.file,
      //     data: item,
      //     exam_id: item.exam_id,
      //     online_class_id: item.rooms[0].pivot.online_class_id,
      //     h5p: item.h5p_content_id,
      //   });
      // });
      res.data.forEach((item) => {
        this.contents.push({
          id: item.get_edu_content.id,
          name: item.get_edu_content.name,
          type: item.get_edu_content.type,
          online_class_id: item.online_class_id,
          start_in: Auth.GetDateTimeZone(item.start_in, true),
          end_in: Auth.GetDateTimeZone(item.end_in, true),
          file: item.get_edu_content.file,
          data: item,
          exam_id: item.get_edu_content.exam_id,
          h5p: item.get_edu_content.h5p_content_id,
          description: item.get_edu_content.description,
        });
      });
      this.load = false;
    },
    back() {
      console.log(this.isShowContent);
      this.isShowContent = 1;
      console.log(this.isShowContent);
      localStorage.removeItem("content");
    },
    async introductoryFile() {
      this.load = true;
      this.isShowContent = 2;

      const res = await eduCourses.Show(this.selectedContentIds);
      this.load = false;
      this.eduCourses = res;
    },
  },
  watch: {
    //
    courseView() {
      this.get();
    },
  },
};
</script>
<style scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
